import "./template_checkout.css";
import Vue from "vue";
import App from "./Checkout.vue";
import store from "./store";

const startApp = () => {
  const el = document.getElementById("template-checkout-view");
  if (el) {
    const props = JSON.parse(el.getAttribute("data"));
    const app = new Vue({
      el: "#template-checkout-view",
      store: store,
      render: h => h(App, { props })
    });
  }
}

window.addEventListener('DOMContentLoaded', startApp);

setTimeout(() => {
  const container = document.getElementById("template-checkout");
  if (!container) {
    console.log('-- starting app after timeout')
    startApp();
  }
}, 1000);
